module.exports = __webpack_public_path__ + "static/pipeline-code-1-8e84132048a60e3c78aa1e7d876da7b1.png";